import { createAuthApi, createAuthStore } from '@ps/auth-client';
import { api } from '../../lib/api';

/** The customer app's single source of truth for who is signed in. */
export const useAuthStore = createAuthStore({
  client: api,
  onSignedOut: () => {
    window.location.assign('/login');
  },
});

export const authApi = createAuthApi(api);

/** This app signs people in as customers; the driver app uses DRIVER. */
export const SIGN_IN_INTENT = 'CUSTOMER' as const;
